import { useEffect, useRef, useState } from 'react'
import { BsCheckLg } from 'react-icons/bs'
import { CgClose } from 'react-icons/cg'
import { toastService } from '../services/toast.service'

// Monday-style action toast: green bar, message, optional Undo, auto-dismiss after `duration`.
export function Toast() {
    const [toast, setToast] = useState(null)
    const timerRef = useRef(null)

    useEffect(() => {
        return toastService.subscribe(t => {
            if (timerRef.current) clearTimeout(timerRef.current)
            setToast(t)
            timerRef.current = setTimeout(() => setToast(null), t.duration || 4000)
        })
    }, [])

    function close() {
        if (timerRef.current) clearTimeout(timerRef.current)
        setToast(null)
    }

    function onAction() {
        if (toast?.onUndo) toast.onUndo()
        close()
    }

    if (!toast) return null
    return (
        <div className="app-toast" role="status">
            <span className="toast-check"><BsCheckLg /></span>
            <span className="toast-msg">{toast.message}</span>
            {toast.onUndo && <button className="toast-undo" onClick={onAction}>{toast.actionLabel || 'Undo'}</button>}
            <CgClose className="toast-close" onClick={close} />
        </div>
    )
}
